import {
  BuildingEnergyRatingType,
  ContentStateInterface,
  EnergyCertificateCreationDate,
} from '../../../../../../@types/types'
import { EnergyCertificateType } from '../../../../../../@types/real-estate-api-types'
import { removeExtraWhitespaces } from '../../../../../../services/conversion/conversionServices'
import { DE, parseDecimal } from '../../../../../../i18next/decimal'
import { EnergySourceOption } from '../../../../../../@types/dropdown-types'

export const energyCertificateToApi = (insertionData: ContentStateInterface): EnergyCertificateType => {
  return {
    firingType: insertionData.constructionEnergySource ?? [EnergySourceOption.NO_INFORMATION],
    buildingEnergyRatingType: insertionData.buildingEnergyRatingType,
    creationDate:
      insertionData.buildingEnergyRatingType === BuildingEnergyRatingType.ENERGY_REQUIRED ||
      insertionData.buildingEnergyRatingType === BuildingEnergyRatingType.ENERGY_CONSUMPTION
        ? EnergyCertificateCreationDate.FROM_01_05_2014
        : undefined,
    efficiencyClass: insertionData.efficiencyClass,
    thermalCharacteristic: parseDecimal(insertionData.thermalCharacteristic, DE),
    consumptionContainsWarmWater: insertionData.consumptionContainsWarmWater ?? false,
    legalConstructionYear: insertionData.legalConstructionYear
      ? removeExtraWhitespaces(insertionData.legalConstructionYear)
      : undefined,
  }
}
